import React from 'react';
import ClientProfileContainer from '../components/client-profile/ClientProfileContainer';

const ClientProfilePage = () => {
  return <ClientProfileContainer />;
};

export default ClientProfilePage;
